export function TypingIndicator() {
  return (
    <div className="flex w-full justify-start">
      <div className="max-w-[85%] sm:max-w-[75%] md:max-w-[65%] lg:max-w-[55%] rounded-lg rounded-bl-none shadow-sm border bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 text-gray-900 dark:text-gray-100 p-4">
        <div className="flex flex-col">
          <div className="flex items-center space-x-1">
            <div className="flex space-x-1">
              <div className="w-2 h-2 bg-current rounded-full animate-bounce [animation-delay:-0.3s]"></div>
              <div className="w-2 h-2 bg-current rounded-full animate-bounce [animation-delay:-0.15s]"></div>
              <div className="w-2 h-2 bg-current rounded-full animate-bounce"></div>
            </div>
            <span className="text-sm opacity-50 ml-2">typing...</span>
          </div>
        </div>
      </div>
    </div>
  );
}
